import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export const STOGarantBanner = () => {
  return <section className="bg-teal-50 py-10 w-full" data-id="element-203">
      <div className="container mx-auto px-4" data-id="element-204">
        <div className="flex flex-col md:flex-row items-center justify-between max-w-4xl mx-auto" data-id="element-205">
          <div className="flex items-center mb-6 md:mb-0" data-id="element-206">
            <ShieldCheckIcon size={48} className="text-teal-600 mr-4" data-id="element-207" />
            <div data-id="element-208">
              <h3 className="text-xl font-bold text-gray-800 mb-1" data-id="element-209">
                STO Garant Protection
              </h3>
              <p className="text-gray-600" data-id="element-210">
                Your booking is secured by STO Garant
              </p>
            </div>
          </div>
          <a href="https://sto-garant.nl/en/downloads" target="_blank" rel="noopener noreferrer" className="bg-white border-2 border-teal-600 hover:bg-teal-600 hover:text-white text-teal-600 font-medium py-2 px-6 rounded-md transition duration-300" data-id="element-211">
            Learn More
          </a>
        </div>
      </div>
    </section>;
};